import ReportGeneralPreview from "./ReportGeneralPreview";
export default ReportGeneralPreview;